var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58859 4.71569L4.64645 4.64645C4.82001 4.47288 5.08944 4.4536 5.28431 4.58859L5.35355 4.64645L10.5 9.793L15.6464 4.64645C15.82 4.47288 16.0894 4.4536 16.2843 4.58859L16.3536 4.64645C16.5271 4.82001 16.5464 5.08944 16.4114 5.28431L16.3536 5.35355L11.207 10.5L16.3536 15.6464C16.5271 15.82 16.5464 16.0894 16.4114 16.2843L16.3536 16.3536C16.18 16.5271 15.9106 16.5464 15.7157 16.4114L15.6464 16.3536L10.5 11.207L5.35355 16.3536C5.17999 16.5271 4.91056 16.5464 4.71569 16.4114L4.64645 16.3536C4.47288 16.18 4.4536 15.9106 4.58859 15.7157L4.64645 15.6464L9.793 10.5L4.64645 5.35355C4.47288 5.17999 4.4536 4.91056 4.58859 4.71569L4.64645 4.64645L4.58859 4.71569Z",
    fill: "#CCD9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ce95ba026d5b1c8b7b9ff4797acd8186.svg";
export { ForwardRef as ReactComponent };